import { useEffect, useState } from "react";
import { api, fmtDate } from "@/lib/api";
import { PageHead } from "@/pages/admin/AdminLayout";
import { Table } from "@/pages/admin/Payments";

export default function AuditLog() {
  const [rows, setRows] = useState([]);
  useEffect(() => {
    api.get("/admin/audit").then((r) => setRows(r.data));
  }, []);
  return (
    <div data-testid="admin-audit">
      <PageHead title="Audit log" />
      <Table head={["When", "Who", "Action", "Target", "Details"]} testid="audit-table">
        {rows.map((a) => (
          <tr key={a.id} className="border-b border-white/5 align-top">
            <td className="px-4 py-3 text-slate-400 whitespace-nowrap">{fmtDate(a.at)}</td>
            <td className="px-4 py-3">{a.actor}</td>
            <td className="px-4 py-3 font-mono-epl text-xs">{a.action}</td>
            <td className="px-4 py-3 font-mono-epl text-xs text-slate-500">{a.target?.slice(0, 8)}</td>
            <td className="px-4 py-3 text-xs text-slate-400 max-w-md break-words">{Object.keys(a.details || {}).length ? JSON.stringify(a.details) : ""}</td>
          </tr>
        ))}
      </Table>
    </div>
  );
}
